import { useEffect } from "react";
import Animated, {
  useAnimatedStyle,
  useReducedMotion,
  useSharedValue,
  withRepeat,
  withTiming,
} from "react-native-reanimated";
import { useMedia, useTheme } from "tamagui";

import { Text } from "../Typography";

// Remap reanimated's internal `forwardedRef` prop to just `ref` to prevent DOM warnings.
const AnimatedText = Animated.createAnimatedComponent(
  ({ forwardedRef, ...props }: any) => <Text {...props} ref={forwardedRef} />,
);

const BlinkingCursor = ({ compact = false }: { compact?: boolean }) => {
  const theme = useTheme();
  const { lg } = useMedia();
  const opacity = useSharedValue(1);
  const reducedMotion = useReducedMotion();

  useEffect(() => {
    opacity.value = withRepeat(withTiming(0, { duration: 600 }), -1, true);
  }, [opacity]);

  const animatedStyle = useAnimatedStyle(
    () => ({
      opacity: opacity.value,
    }),
    [opacity],
  );

  if (reducedMotion) return null;

  const getCursorSize = () => {
    if (compact) return "$md";
    return lg ? "$3xl" : "$xxl";
  };

  return (
    <AnimatedText
      aria-hidden
      color={theme.textPrimary.get()}
      display="inline"
      size={getCursorSize()}
      style={animatedStyle}
    >
      |
    </AnimatedText>
  );
};

export default BlinkingCursor;
